import React from 'react';

export const PeriodFilter = ({ months, fromIdx, toIdx, onFromChange, onToChange, onApply, onReset, periodLabel, isFiltered, loading }) => {
  if (!months || !months.length) return null;

  return (
    <div className="flex items-center gap-2.5 flex-wrap" data-testid="period-filter">
      <span className="text-[11px] font-mono uppercase tracking-wider text-dash-mut">Period</span>
      <select
        value={fromIdx}
        onChange={(e) => onFromChange(Number(e.target.value))}
        disabled={loading}
        className="bg-dash-panel text-dash-ink border border-dash-line rounded-md px-2.5 py-1.5 text-xs font-mono focus:outline-none focus:border-dash-ice"
        data-testid="period-from"
      >
        {months.map((m, i) => (
          <option key={i} value={i}>{m}</option>
        ))}
      </select>
      <span className="text-dash-mut text-xs">to</span>
      <select
        value={toIdx}
        onChange={(e) => onToChange(Number(e.target.value))}
        disabled={loading}
        className="bg-dash-panel text-dash-ink border border-dash-line rounded-md px-2.5 py-1.5 text-xs font-mono focus:outline-none focus:border-dash-ice"
        data-testid="period-to"
      >
        {months.map((m, i) => (
          <option key={i} value={i}>{m}</option>
        ))}
      </select>
      <button
        onClick={onApply}
        disabled={loading}
        className="bg-dash-coral text-white border-none rounded-md px-3.5 py-1.5 text-[11px] font-bold tracking-wider cursor-pointer hover:brightness-110 transition disabled:opacity-60 disabled:cursor-wait"
        data-testid="period-apply"
      >
        {loading ? 'APPLYING…' : 'APPLY'}
      </button>
      {isFiltered && (
        <button
          onClick={onReset}
          disabled={loading}
          className="bg-transparent text-dash-mut border border-dash-line rounded-md px-3 py-1.5 text-[11px] cursor-pointer hover:text-dash-ink transition disabled:opacity-60"
          data-testid="period-reset"
        >
          Reset to all
        </button>
      )}
      <span className="ml-auto text-[11px] font-mono text-dash-mut" data-testid="period-label">
        {periodLabel}
      </span>
    </div>
  );
};
